<template>
  <JuryInstructionsReportModal
    v-if="showReportModal"
    @close="showReportModal = false"
    :juryInstructions="selectedInstructions"
  >
  </JuryInstructionsReportModal>
  <JuryInstructionsDetailsModal
    v-if="showDetailsModal"
    @close="closeViewInstructionModal"
    :juryInstruction="selectedInstruction"
  ></JuryInstructionsDetailsModal>
  <div class="col-12 d-flex flex-column px-0 border-left">
    <!-- Your HTML content goes here -->
    <h1 class="section-header fw-bold pl-5 pb-3">Jury Instructions</h1>
    <div class="w-100 scrollable overflow-auto" style="max-height: 70vh">
      <table class="fs-5 border-top border-botttom border-right mb-3 w-100">
        <thead class="border-bottom">
          <tr style="height: 58px">
            <th class="fs-5 text-center pl-5">CALCRIM Number</th>
            <th class="fs-5 text-center">Instruction</th>

            <th class="fs-5"></th>
            <th class="fs-5">Include in Report</th>
          </tr>
        </thead>
        <tbody v-if="instructions?.length > 0">
          <tr style="height: 58px" class="border-bottom" v-for="instruction in instructions" :key="instruction.Id">
            <td class="pl-5">{{ instruction.InstructionNumber }}</td>
            <td class="">{{ parseUnicode(instruction.InstructionTitle) }}</td>

            <td class="">
              <button class="btn btn-primary-outline btn-xl" @click="viewInstruction(instruction)">View</button>
            </td>
            <td v-if="!includeAll" class="clickable text-center" @click="toggleSelected(instruction)">
              <!-- <button
                      class="btn btn-xl"
                      :class="
                        instructionIsSelected(instruction.Id) ? 'btn-secondary' : 'btn-primary'
                      "
                      @click="toggleSelected(instruction)"
                    >
                      {{ instructionIsSelected(instruction.Id) ? "Exclude" : "Include" }}
                    </button> -->
              <input type="checkbox" style="width: 20px; height: 20px" class="ml-5" v-model="instruction.include" />
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" class="text-center">We couldn't find any CALCRIM Jury Instructions associated with this case</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pl-5">
      <button v-if="instructions?.length > 0" class="btn btn-xl btn-primary mt-5" @click="showReportModal = true">
        Generate Report
      </button>
    </div>
    <p class="my-3 fs-6 pl-5">
      No copyright is claimed to the jury instructions and related material which are attributed to the Judicial Council of
      California.
    </p>
  </div>
</template>

<script>
import axios from "axios";
import JuryInstructionsDetailsModal from "./JuryInstructionsDetailsModal.vue";
import JuryInstructionsReportModal from "../../JuryInstructions/JuryInstructionsReportModal.vue";
export default {
  name: "JuryInstructions",
  props: ["charges", "selectedCase", "caseJuryInstructions"],
  components: {
    JuryInstructionsReportModal,
    JuryInstructionsDetailsModal,
  },
  data() {
    return {
      instructions: [],
      showReportModal: false,
      // selectedInstructions: [],
      includeAll: false,
      showDetailsModal: false,
      selectedInstruction: null,
    };
  },

  computed: {
    selectedInstructions() {
      return this.instructions.filter((instruction) => instruction.include == true || this.includeAll);
    },
  },
  methods: {
    instructionIsSelected(instructionId) {
      return (
        this.selectedInstructions.findIndex((instruction) => {
          return instruction.Id == instructionId;
        }) != -1
      );
    },
    viewInstruction(instruction) {
      // let instructionText = "";
      // instruction.subsections.forEach((subsection) => {
      //   instructionText += `\n\n${this.parseUnicode(subsection.SectionTitle)}\n\n`;
      //   instructionText += this.parseUnicode(subsection.SectionText);
      // });
      // this.$emit("displayJuryInstructionsPopup", {
      //   header: this.parseUnicode(instruction.InstructionTitle),
      //   body: instructionText,
      // });
      this.showDetailsModal = true;
      this.selectedInstruction = instruction;
    },
    closeViewInstructionModal() {
      this.showDetailsModal = false;
      this.selectedInstruction = null;
    },
    parseUnicode(str) {
      str = str.replaceAll("&amp;", "&");
      str = str.replaceAll("&quot;", '"');
      str = str.replaceAll("&gt;", ">");
      str = str.replaceAll("&lt;", "<");
      //str = str.replace(/\n\n.*?\n\n\d+\s*\n\n/g, '\n');
      str = str.replace(/\n\n\d+\s*\n\n/g, "\n");

      return str;
    },
    toggleSelected(instruction) {
      let foundIndex = this.selectedInstructions.findIndex((selectedInstruction) => {
        return selectedInstruction.Id == instruction.Id;
      });
      // console.log(foundIndex);
      if (foundIndex == -1) {
        this.selectedInstructions.push(instruction);
      } else {
        this.selectedInstructions.splice(foundIndex, 1);
      }
    },
  },
  async mounted() {
    if (!this.caseJuryInstructions?.length) {
      axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/juryInstructions/byCase/" + this.selectedCase?.Id, {
          headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
        })
        .then((data) => {
          this.instructions = data.data?.instructions;
          this.instructions.forEach((instruction) => {
            instruction.subsections = data?.data?.subsections.filter((subsection) => {
              return subsection.JuryInstructionId == instruction.Id;
            });
            instruction.include = true;
          });
        });
    } else {
      this.instructions = this.caseJuryInstructions;
    }

    this.instructions?.forEach((instruction) => {
      this.selectedInstructions.push(instruction);
    });
  },
};
</script>

<style scoped>
.table-container {
  max-height: 60vh !important;
  overflow-y: auto;
}

/* Your component-specific styles go here */
</style>
